import React, { useEffect, useRef, useState } from "react";
import Peer from "peerjs";

const Streamer = () => {
  const [peerId, setPeerId] = useState(null);
  const [remotePeerId, setRemotePeerId] = useState('');
  const peerRef = useRef(null);
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const localStreamRef = useRef(null);
  const [videoOn, setVideoOn] = useState(true);
  const [screenStream, setScreenStream] = useState(null);

  useEffect(() => {
    // PeerJS 연결 설정
    const uniqueId = `${Math.floor(Math.random() * 10000)}`;
    const peer = new Peer(uniqueId, {
      host: process.env.REACT_APP_DOMAIN, // ⚠️ 로컬 IP 사용
      port: 4000,             // HTTPS 포트
      path: '/peerjs',
      secure: true,  
    });
    
    peerRef.current = peer;

    // Peer ID가 열리면, 화면에 표시
    peer.on('open', (id) => {
      console.log('📡 Streamer Ready! Your ID:', id);
      setPeerId(id);
    });

    peer.on("call", (call) => {
      console.log("📞 Viewer에서 오디오 수신 요청:", call.peer);
      // call.answer(); // Viewer가 보내는 오디오 스트림 수락
      call.answer(localStreamRef.current); // 📤 내 stream 응답
  
      call.on("stream", (remoteStream) => {
        // const audio = new Audio();
        // audio.srcObject = remoteStream;
        // audio.play().catch(err => console.error("🔈 오디오 재생 실패:", err));
        if (remoteVideoRef.current) {
          remoteVideoRef.current.srcObject = remoteStream;
          remoteVideoRef.current.play().catch(console.error);
          // remoteVideoRef.current.muted = true;
          // remoteVideoRef.current.play();
        }
      });
    });
    
    // 오류 처리
    // peerRef.current.on('error', (err) => console.error('🚨 PeerJS 오류:', err));
    return () => peer.destroy();
  }, []);

  const startCall = async () => {
    if (!remotePeerId) {
      alert("상대방의 Peer ID를 입력하세요.");
      return;
    }

    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
    localStreamRef.current = stream;
    localVideoRef.current.srcObject = stream;
    localVideoRef.current.muted = true;
    await localVideoRef.current.play();

    const call = peerRef.current.call(remotePeerId, stream);

    call.on("stream", (remoteStream) => {
      remoteVideoRef.current.srcObject = remoteStream;
      remoteVideoRef.current.play().catch(console.error);
    });
  };

  const toggleVideo = () => {
    const videoTrack = localStreamRef.current.getVideoTracks()[0];
    videoTrack.enabled = !videoTrack.enabled;
    setVideoOn(videoTrack.enabled);
  };

  const startScreenShare = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
        audio: true,
      });
  
      setScreenStream(stream);
  
      // 예시: 상대방에게 공유
      const call = peerRef.current.call(remotePeerId, stream);
      // ...
    } catch (err) {
      console.error("🚨 화면 공유 실패:", err);
    }
  };
  
  const stopScreenShare = () => {
    if (screenStream) {
      screenStream.getTracks().forEach(track => track.stop());
      setScreenStream(null);
    }
  };

  return (
    <div>
      <h2>📱 송출 화면</h2>
      <p>Streamer ID: {peerId}</p>
      <p>뷰어 화면에서 제공하는 Viewer ID를 입력하고 통화 시작버튼을 눌러주시기 바랍니다.</p>
      <input
        placeholder="Viewer ID"
        value={remotePeerId}
        onChange={(e) => setRemotePeerId(e.target.value)}
      />
      <button onClick={startCall}>통화 시작</button>
      <div style={{display:"flex",flexDirection:"column"}}>
        <div>
          <h3>🎥 내 화면</h3>
          <video ref={localVideoRef} autoPlay playsInline controls muted style={{ width: "300px",
            // display: videoOn ? "none" : "block", // 🔥 숨기기
           }} />
            <br/><button onClick={toggleVideo}>
              {videoOn ? "📴 내 영상 끄기" : "📹 내 영상 켜기"}
            </button>
            {/* <button onClick={screenStream ? stopScreenShare : startScreenShare}>
              {screenStream ? "🛑 화면 공유 중단" : "🖥 화면 공유 시작"}
            </button> */}
        </div>
        <div>
          <h3>👀 상대 화면</h3>
          <video ref={remoteVideoRef} autoPlay playsInline controls style={{ width: "300px" }} />
        </div>
      </div>
      <p>뷰어 주소 : https://{process.env.REACT_APP_DOMAIN}/viewer</p>
    </div>
  );
};

export default Streamer;